// src/context/DashboardContext.js
import React, { createContext, useContext, useState } from 'react';
import { getGlobalState, setGlobalState } from '../utils/globalState';
import { addUserDashboard } from '../utils/api';

const DashboardContext = createContext();

export const useDashboard = () => useContext(DashboardContext);

export const DashboardProvider = ({ children }) => {
  const [myTreeData, setMyTreeData] = useState(null);

  const handleAddToMyDashboards = async (dashboard) => {
    const { myFolderId } = getGlobalState();
    dashboard.parent_id = 'f_' + myFolderId;
    await addUserDashboard('f_' + myFolderId, dashboard.id);
    handleAddItem(dashboard, 'f_' + myFolderId);
  };

  const handleAddItem = (newDashboard, parentId) => {
    newDashboard.parent_id = parentId;

    const addDashboardToTree = (tree, parentId, newDashboard) => {
      return tree.map(node => {
        if (node.id === parentId) {
          const existingDashboard = (node.children || []).find(child => child.id === newDashboard.id);
          if (!existingDashboard) {
            return {
              ...node,
              children: [...(node.children || []), newDashboard]
            };
          }
        }
        if (node.children) {
          return {
            ...node,
            children: addDashboardToTree(node.children, parentId, newDashboard)
          };
        }
        return node;
      });
    };

    setMyTreeData(prevTree => {
      const updatedTree = addDashboardToTree(prevTree, parentId, newDashboard);
      setGlobalState({ myTreeData: updatedTree });
      return updatedTree;
    });
  };

  return (
    <DashboardContext.Provider value={{ myTreeData, setMyTreeData, handleAddToMyDashboards }}>
      {children}
    </DashboardContext.Provider>
  );
};